// Display helpers for dates and times in the user's preferred format (dd/mm/yyyy).
export function formatDate(dateStr) {
  if (!dateStr) return "—";
  // Accept "YYYY-MM-DD" or ISO; we only care about the date part.
  const m = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return String(dateStr);
  return `${m[3]}/${m[2]}/${m[1]}`;
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function isUpcoming(dateStr) {
  if (!dateStr) return false;
  return String(dateStr) >= todayISO();
}
